import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const Campus: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.992 2.80423V4.60046L10.71 4.62957C9.50944 4.75356 8.49074 4.99509 7.452 5.40211C6.79346 5.66016 6.2602 5.94168 5.766 6.29227L5.496 6.48379V9.74589V13.008H3.252H1.008V18V22.992L3.252 22.9938C4.4862 22.9949 8.4228 22.9957 12 22.9957C15.5772 22.9957 19.5138 22.9949 20.748 22.9938L22.992 22.992V18V13.008H20.748H18.504V9.74589V6.48379L18.234 6.29227C17.7398 5.94168 17.2065 5.66016 16.548 5.40211C15.5093 4.99509 14.4905 4.75356 13.29 4.62957L13.008 4.60046V3.80023V3H14.004H15V2.004V1.008H12.996H10.992V2.80423ZM11.352 6.59004C10.4346 6.66667 9.99151 6.73476 9.33261 6.90031C8.7923 7.03605 8.22002 7.23664 7.758 7.45214L7.512 7.56691V14.2835V21H9.252H10.992V19.5V18H12H13.008V19.5V21H14.748H16.488V14.2835V7.56691L16.242 7.45214C15.3576 7.03963 14.3149 6.76125 13.1776 6.63408C12.8722 6.59995 11.6007 6.56925 11.352 6.59004ZM11.5421 9.03724C10.1145 9.29575 9.12765 10.5761 9.2633 11.9937C9.32791 12.669 9.57967 13.2061 10.0546 13.6817C10.4299 14.0576 10.8565 14.3005 11.3678 14.4293C11.5471 14.4745 11.6452 14.4828 12 14.4828C12.4849 14.4828 12.6847 14.4447 13.0786 14.2771C13.6516 14.0333 14.1764 13.5437 14.4557 12.9924C15.0528 11.8141 14.7094 10.3411 13.654 9.55288C13.0572 9.10728 12.2473 8.90954 11.5421 9.03724ZM11.6943 11.075C11.1578 11.3248 11.1053 12.047 11.6001 12.3715C11.9956 12.6309 12.5265 12.4518 12.6978 12.0011C12.8316 11.649 12.658 11.239 12.3057 11.075C12.2076 11.0293 12.1404 11.0165 12 11.0165C11.8596 11.0165 11.7923 11.0293 11.6943 11.075ZM3 18V21H4.248H5.496V18V15H4.248H3V18ZM18.504 18V21H19.752H21V18V15H19.752H18.504V18Z'
        fill={fill}
      />
    </svg>
  )
}

export default Campus
